

function MyRoute(locationx,paramName)
{
    var hash = locationx.split("#");
   
    var param = hash[0].split('/');

    

    for(var k=0; k<param.length-1; k++)
    {
        if(k < 2) continue;

        if(param[k] == paramName )
        {
            return param[k+1];
        }
    }


    return null;
}

export default MyRoute;